<template>

  <b-container style="flex: available">
    <b-container style="margin: 15px">
      <p>Thank you for your interest in becoming a Napa Green or Beyond Green Certified Regenerative Vineyard. We work
          hand in hand with our members to take a whole system approach to sustainability and climate action across
          our <a href="https://napagreen.org/six-pillars/">
          "Six Pillars of Sustainable Winegrowing Leadership."</a> Our vineyard certification launched in 2022,
          and is the first sustainable winegrowing certification to focus on regenerative viticulture, climate action,
        and caring for people.
        </p>

      <p>Napa Green Vineyards implement >90 leading practices, enhancing soil health and biodiversity, reducing
        emissions
        and drawing down carbon, and increasing the resilience of vineyards, businesses, and our community. Critically,
        Napa Green and Beyond Green vineyards track their performance, to ensure these practices are achieving real
        results and continuing improvement over time.</p>

      <p>Our nonprofit has an expert team that will work with you closely throughout the certification process.
        There is a $250 application fee, which will cover the time to onboard your team and ensure they understand
        the steps to certification, including the value-add Carbon Farm Plans and Irrigation Assessments.
        We are always available to answer questions – please reach out to vineyard@napagreen.org
      </p>

      <p>Once you fill out and submit the information below you will be sent an email with your username and temporary
        password to access the Vineyard Certification Portal.</p>

        <p><span style="font-style: italic">Note: This information is kept confidential.</span></p>

    </b-container>
    <b-container>
      <span style="margin-top: 10px"><br/></span>
      <b-container fluid>
        <b-container fluid>
          <b-card bg-variant="light">

            <b-form-group
                label-cols-sm="4"
                label="Company Name*:"
                label-align-sm="left"
                label-for="nested-street"
            >
              <b-form-input id="name" size="sm" v-model="name"
                            placeholder="Company Name"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-size="md"
                label="Company Mailing Address*:"
                label-align-sm="left"
                label-for="nested-street"
            >
              <b-form-input id="address" size="sm" v-model="address"
                            placeholder="Company Address"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="County*:"
                label-for="input-sm">
              <b-form-select
                  v-model="county"
                  :options="countyMap">
              </b-form-select>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Contact Name (Vineyard Manager/Management Company)*:"
                label-for="input-sm">
              <b-form-input id="contactName" size="sm" v-model="contactName"
                            placeholder="Contact Name"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Contact Title*: "
                label-for="input-sm">
              <b-form-input id="contactTitle" size="sm" v-model="contactTitle"
                            placeholder="Contact Title"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Contact Phone Number*:"
                label-for="input-sm">
              <b-form-input id="contactTelephoneNumber" size="sm"
                            v-model="contactTelephoneNumber" placeholder="Contact Phone Number"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Contact Email Address*:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="contactEmail"
                            placeholder="Contact Email"/>
            </b-form-group>


            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Owner/Leadership Name*: "
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="ownerName"
                            placeholder="Owner Name"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Owner/Leadership Phone Number:"
                label-for="input-sm">
              <b-form-input id="telephoneNumber" size="sm"
                            v-model="ownerTelephoneNumber" placeholder="Owner Telephone Number"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Owner/Leadership Email Address*:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="ownerEmail"
                            placeholder="Owner Email"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Accountant Name*: "
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="accountantName"
                            placeholder="Accountant Name"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Accountant Email Address*:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="accountantEmail"
                            placeholder="Accountant Email"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Communications/Marketing Contact:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="communicationsContact"
                            placeholder="Communications/Marketing Contact"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Communications/Marketing Email:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="communicationsContactEmail"
                            placeholder="Communications/Marketing Email"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Vineyard Name(s)*:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="vineyardNames"
                            placeholder="Vineyard Names"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Vineyard Address(es)*:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="vineyardAddresses"
                            placeholder="Vineyard Addresses"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Total Property Acres (for each non-contiguous parcel)*:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="totalPropertyAcres"
                            placeholder="Total Property Acres"/>
            </b-form-group>
            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Vineyard Acres (for each non-contiguous parcel)*:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="vineyardAcres"
                            placeholder="Vineyard Acres"/>
            </b-form-group>
            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Varieties Planted:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="varietiesPlanted"
                            placeholder="Varieties Planted"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Age Of Vines:"
                label-for="input-sm">
              <b-form-input id="input-sm" size="sm" v-model="ageOfVines"
                            placeholder="Age of Vines"/>
            </b-form-group>


            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="Are you planning a vineyard replant or new development within the next three years?:"
                label-for="input-sm">
              <b-form-radio-group
                  v-model="imminentPlanting"
                  :options="yesNoOptions"
                  name="waterMeterTracking"
                  stacked
              />
            </b-form-group>


            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="When was your last Irrigation Distribution Uniformity Assessment?:"
                label-for="input-sm">
              <datepicker v-model="lastIDUAssessment" name="lastIDUDatePicker"
                          style="width: 50%" placeholder="Last Irrigation Distribution Uniformity Assessment Date"/>
            </b-form-group>

            <b-form-group
                label-cols="4"
                label-cols-lg="4"
                label-size="md"
                label="When did you last conduct soil testing?:"
                label-for="input-sm">
              <datepicker v-model="lastSoilTesting" name="lastSoilDatePicker"
                          style="width: 50%" placeholder="Last Soil Testing"/>
            </b-form-group>

            <b-container fluid>

              <b-form-group label="Indicate current certifications (Check Relevant):">
                <b-form-checkbox-group
                    v-model="certifications"
                    :options="certificationsOptions"
                    name="renewableEnergyInstalled"
                    stacked
                />
              </b-form-group>

              <b-form-group label="Indicate current practices (Check Relevant):">
                <b-form-checkbox-group
                    v-model="practices"
                    :options="practicesOptions"
                    name="renewableEnergyInstalled"
                    stacked
                />
              </b-form-group>

            </b-container>

            <div class="button-holder">
              <b-row align-h="center">
                <b-col cols="2"/>
                <b-col cols="8">*Questions marked with an asterisk must be completed to submit the
                  form.
                </b-col>
                <b-col cols="2"/>
              </b-row>
            </div>

            <div class="button-holder">
              <b-row align-h="center">
                <b-col cols="2">
                  <b-button id="submitButton" style="color: white; background-color: green"
                            class="submit-button"
                            type="submit" @click="submit"
                            variant="primary" :disabled="!canSubmit">Submit
                  </b-button>
                </b-col>
                <b-col cols="2">
                  <b-button style="color: white; background-color: green" class="cancel-button"
                            type="cancel" @click="cancel"
                            variant="primary">Cancel
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-container>
      </b-container>
    </b-container>
  </b-container>


</template>
<script>

import swal from 'sweetalert';
import Datepicker from "vuejs-datepicker";

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export default {
  name: "RequestVineyardAccount",
  components:{
    Datepicker
  },
  data() {
    return {
      errors: [],
      requiredText: "*Required",
      name: '',
      address: '',
      contactName: '',
      contactTitle: '',
      contactTelephoneNumber: '',
      contactEmail: '',
      ownerName: '',
      ownerEmail: '',
      ownerTelephoneNumber: '',
      vineyardNames: '',
      vineyardAddresses: '',

      totalPropertyAcres: '',
      vineyardAcres: '',
      varietiesPlanted: '',
      ageOfVines: '',
      imminentPlanting: '',
      vineyardApns: '',
      lastIDUAssessment: '',
      lastSoilTesting: '',

      practices: [],
      practicesOptions: ["Have Carbon Farm Plan",
        "Compost",
        "Biochar",
        "Conservation tillage",
        "No-tillage",
        "Dry farming", "Livestock grazing",
        "Hedgerows", "Riparian/River/Ditch Restoration"],
      certifications: [],
      certificationsOptions: ["CCSW", "Organic", "Demeter Biodynamic"],
      yesNoOptions: ["Yes", "No"],
      county: null,
      countyMap: [{text: "", value: null},
                  {text: "Napa", value: "28"},
                  {text: "Lake", value: "17"},
                  {text: "Marin", value: "21"},
        {text: "Mendocino", value: "23"},
        {text: "Sonoma", value: "49"},
                  {text: "Solano", value: "48"}],
      isSubmitted: true,
      accountantName: '',
      accountantEmail: '',
      communicationsContact: '',
      communicationsContactEmail: ''
    }
  },
  computed: {
    validateBusinessName: function () {
      let isValid = this.name !== "Business Name" && this.name !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateBusinessAddress: function () {
      let isValid = this.address !== "Business Address" && this.address !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactName: function () {
      let isValid = this.contactName !== "Contact Name" && this.contactName !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactTelephoneNumber: function () {
      let isValid = this.contactTelephoneNumber !== "Telephone" && this.contactTelephoneNumber !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactEmail: function () {
      let isValid = this.validateEmailAddress(this.contactEmail);
      console.log("Email Address valid: " + isValid);
      return isValid;
    },
    canSubmit: function () {
      let self = this;
      /*      return this.validateContactEmail && this.validateContactTelephoneNumber
                && this.validateContactName && this.validateBusinessAddress && this.validateBusinessName;*/
      return self.validateEmailAddress(self.contactEmail)
          && self.isFieldValid(self.contactName, "Contact Name")
          && self.isFieldValid(self.contactTitle, "Contact Title")
          && self.isFieldValid(self.contactTelephoneNumber, "Contact Phone Number")
          && self.isFieldValid(self.contactEmail, "Contact Email")
          && self.isFieldValid(self.name, "Company Name")
          && self.isFieldValid(self.address, "Company Address")
          && self.isFieldValid(self.ownerName, "Owner Name")
          && self.isFieldValid(self.ownerEmail, "Owner Email Address")
          && self.isFieldValid(self.totalPropertyAcres, "Total Property Acres")
          && self.isFieldValid(self.vineyardAcres, "Vineyard Acres")
          && self.isFieldValid(self.accountantName, "Accountant Name")
          && self.validateEmailAddress(self.accountantEmail, "Accountant Name")
          && self.isFieldValid(self.vineyardNames, "Vineyard Names")
          && self.isFieldValid(self.vineyardAddresses, "Vineyard Addresses")
          && self.isFieldValid(self.county, "County");
    }
  },

  methods: {
    cancel: function () {
      alert('cancel');
    },
    validateEmail: function (mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true
      }
      return false
    },

    makeToast: function(message){
      this.$toasted.info(message, {
        containerClass: 'super-toasty',
        iconPack: 'fontawesome',
        closeOnSwipe: true,
        action: {
          text: 'DISMISS',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        },
        icon: {
          name: 'fa-exclamation-triangle',
          after: false
        }
      })
    },
    validateEmailAddress: function (email) {
      let isValid = emailRegex.test(String(email).toLowerCase());
      /*      if (!isValid){
              this.makeToast("You have entered an invalid email address!")
            }*/
      return isValid;
    },
    isFieldValid: function (fieldValue, defaultValue) {
      console.log(Object.keys(fieldValue));
      return fieldValue !== defaultValue && fieldValue !== "";
    },
    validateForm: function (self, data) {
      return self.validateEmailAddress(data.contactEmail)
          && self.isFieldValid(data.contactName, "Contact Name")
          && self.isFieldValid(data.contactTitle, "Contact Title")
          && self.isFieldValid(data.contactTelephoneNumber, "Contact Phone Number")
          && self.isFieldValid(data.contactEmail, "Contact Email")
          && self.isFieldValid(data.name, "Company Name")
          && self.isFieldValid(data.address, "Company Address")
          && self.isFieldValid(data.ownerName, "Owner Name")
          && self.isFieldValid(data.ownerEmail, "Owner Email Address")
          && self.isFieldValid(data.totalPropertyAcres, "Total Property Acres")
          && self.isFieldValid(data.vineyardAcres, "Vineyard Acres")
          && self.isFieldValid(data.county, "County");
    },
    buildValidationMessage: function () {
      return "Please enter a valid email address.";
    },
    submit: function () {
      event.target.disabled = true;
      let self = this;
      let data = {
        name: this.name,
        address: this.address,
        contactName: this.contactName,
        contactTitle: this.contactTitle,
        contactTelephoneNumber: this.contactTelephoneNumber,
        contactEmail: this.contactEmail,
        ownerName: this.ownerName,
        ownerEmail: this.ownerEmail,
        ownerTelephoneNumber: this.ownerTelephoneNumber,
        vineyardNames: this.vineyardNames,
        county: this.county,

        totalPropertyAcres: this.totalPropertyAcres,
        vineyardAcres: this.vineyardAcres,
        varietiesPlanted: this.varietiesPlanted,
        ageOfVines: this.ageOfVines,
        imminentPlanting: this.imminentPlanting,
        vineyardApns: this.vineyardApns,
        lastIDUAssessment: this.lastIDUAssessment,
        lastSoilTesting: this.lastSoilTesting,
        entityType: "VINEYARD",
        practices: this.practices,
        certifications: this.certifications,
        status: 'PENDING',
        accountantName: this.accountantName,
        accountantEmail: this.accountantEmail,
        communicationsContact: this.communicationsContact,
        communicationsContactEmail: this.communicationsContactEmail

      };
      console.log("V Request");
      console.log(data);
      swal("THANK YOU", "Your request has been submitted.", "success");
      self.$http.post('account/vineyard-request', data, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(function (response) {
        console.log(response.data);
        self.$router.push({path: '/account-requested?type=vineyard'});
      })
          .catch(function (error) {
            console.log("Something went really wrong: ", error);
          });
    }
  }
}
</script>
<style>
.invalid-field {
  color: red;
  size: 14px;
  font-style: italic;
}
</style>
